import React from 'react'

// thir party and libarries
import { Table } from "react-bootstrap"
import { LINEAR_GRADIENT_BG } from '../../const'
import { covertTimeZone, numberFormat } from '../../helper'
import AnimationLoading from '../../components/Animationloading'
import _ from 'lodash'

export default function OrderTables({ orderListDatas, saleOrders, _limit, _skip, loadingOrders }) {

    const calculatorCost = (_stock, saleAmount) => {

        let newTotalCost = 0;
        if (!_.isEmpty(_stock?.originPrice)) { // ຖ້າບໍ່ມີລາຄາຕົ້ນທືນ ໃຫ້ຄຳນວນ ລາຄາຂາຍ ແຫນ
            newTotalCost = _stock?.originPrice * saleAmount;
            return newTotalCost;
        } else { // ນອກຈາກນັ້ນ ໃຫ້ຄຳນວນ ລາຄາຕົ້ນທືນ ໄປໄດ້
            newTotalCost = _stock?.price * saleAmount;
            return newTotalCost;
        }

    }

    const calculatorProfit = (originPrice, saleAmount, saleTotalPrice) => {

        let newTotal = 0;
        if (originPrice) {
            newTotal = saleTotalPrice - (originPrice * saleAmount)
        }
        return newTotal;

    }

    if (!orderListDatas?.datas) return <div>Empty Orders...</div>
    if ((loadingOrders && !saleOrders)) return <AnimationLoading />

    return (
        <Table responsive>
            <thead style={{
                background: LINEAR_GRADIENT_BG,
                borderRadius: " 8px 8px 0px 0px",
                color: "#FFFFFF",
            }}>
                <tr>
                    <th>#</th>
                    <th>ບຣາໂຄດ</th>
                    <th>ຊື່ສິນຄ້າ</th>
                    <th>ສະຕ໋ອກ</th>
                    <th>ຈຳນວນຂາຍ</th>
                    <th>ສະຕ໋ອກທີ່ເຫຼືອ</th>
                    <th>ຕົ້ນທືນ</th>
                    <th>ຍອດຂາຍ</th>
                    <th>ກຳໄລ</th>
                    <th>ວັນທີ,ເດືອນ,ປີ</th>
                </tr>
            </thead>
            <tbody>
                {orderListDatas?.datas.map((item, index) => (
                    <tr key={index}>
                        <td>{index + 1 + _limit * (_skip - 1)}</td>
                        <td>{item?.stock?.barCode ?? "-"}</td>
                        <td>{item?.productName ?? item?.stock?.name}</td>
                        <td>{(item?.stock?.amount + item?.amount) ?? 0}</td>
                        <td>{item?.amount ?? 0}</td>
                        <td>{item?.stock?.amount ?? 0}</td>
                        <td>₭ {numberFormat(item?.totalPrice ?? 0)}</td>
                        <td>₭ {numberFormat(calculatorCost(item?.stock, item?.amount))}</td>
                        <td>₭ {numberFormat(calculatorProfit(item?.stock?.originPrice, item?.amount, item?.totalPrice))}</td>
                        <td>{covertTimeZone(item?.createdAt)}</td>
                    </tr>
                ))}
            </tbody>

        </Table>
    )
}
